export default "/profile/images/Uspacy.svg?2c8a3b0ad0ec2339e21b3ccf33616d0e";